import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=71514ed6&scoped=true&"
import script from "./confirmation.vue?vue&type=script&lang=ts&"
export * from "./confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=71514ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71514ed6",
  null
  
)

export default component.exports